export default "/accepted";
